/** A ₾ amount typed into a field: a comma is a decimal point, empty or junk
 *  is ₾0, never negative, rounded to the tetri (137's salary field). */
export function parseMoneyInput(s: string): number {
  const n = parseFloat(s.replace(',', '.'))
  return Number.isFinite(n) && n > 0 ? Math.round(n * 100) / 100 : 0
}
